import React from 'react';
import NextHead from 'next/head';

import SETTINGS from '../../settings';

const ScriptMarkupOrganization = () => (
  <NextHead>
    <script
      key="ScriptMarkupOrganization"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Parabo Press",
  "url": "${SETTINGS.HOST}/",
  "logo": "${SETTINGS.HOST}/static/img/logo.png",
  "sameAs": [
    "https://twitter.com/parabopress/",
    "https://www.facebook.com/parabopress/",
    "https://www.instagram.com/parabopress/",
    "https://www.pinterest.com/parabopress/"
  ]
}`,
      }}
    />
  </NextHead>
);

export default ScriptMarkupOrganization;
